import React, { useState, useEffect } from "react";
import "./DMSHeader.css";
import ImportPopup from "../Common/ImportPopup/ImportPopup";
import {
  Dataview,
  Goback,
  Reload,
  Menu,
} from "../../../Components/IconComponents";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch } from "react-redux";
import { setTableData } from "../../../CentralStore/ExportLMSTable/dataSlice";
import ExportTableData from "../../../Components/UiComponents/Table/TableComponents/ExportTableData/ExportTableData";
import ExportTableDataAvalanche from "../../../Components/UiComponents/Table/TableComponents/ExportTableData/ExportTableDataAvalanche";

const height = "1.2rem";
const width = "1.2rem";

const DMSHeader = ({
  title,
  subtitle,
  vehicleNumber,
  subName,
  status,
  showIconsForback,
  showicons,
  data,
  showdownload,
  showdownloadAvalanche,
  importEndpoint = "",
  downloadTemplate,
  fileName,
  showImportDropDownLabel = true,
  increaseHeaderHeight
}) => {
  const navigate = useNavigate();
  const [showImport, setShowImport] = useState(false);
  const dispatch = useDispatch();

  const dataFromStore = useSelector((state) => state.data);

  useEffect(() => {
    return () => {
      dispatch(setTableData({ columns: [], tableData: [] }));
    };
  }, []);

  const importpop = () => {
    setShowImport(!showImport);
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      <Menu />
    </a>
  ));

  return (
    <div className="lms__header" style={{
      ...(increaseHeaderHeight && { height: "42px", marginTop: "-11px" }),
      ...(subtitle && { padding: "6px 1rem" }),
    }}>
      <div className="lms__title" style={subtitle ? { display: "flex", flexDirection: "column", gap: "2px" } : {}}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {showIconsForback && (
            <span style={{ marginRight: "10px" }}>
              <Goback
                className="cursor-pointer"
                style={{ marginTop: "-2px" }}
                height={height}
                width={width}
                onClick={() => navigate(-1)}
              />
            </span>
          )}
          {title} {vehicleNumber}
        </div>
        {subtitle && (
          <div style={{ fontSize: "0.75rem", fontWeight: "400", color: "#6c757d", lineHeight: "0.7" }}>
            {subtitle}
          </div>
        )}
      </div>

      <div className="lms__title">
        {subName}
        {status === "In Transit" ? (
          <span className="lms__status--transit">{status}</span>
        ) : (
          <span className="lms__status--delivery">{status}</span>
        )}
      </div>

      <span className="lms__title_icon">
        {showicons && (
          <span className="lms__icons">
            <Reload />
          </span>
        )}
        {showicons && (
          <span className="lms__icons">
            <Dataview />
          </span>
        )}
        {showdownload && (
          <ExportTableData
            data={dataFromStore.tableData}
            columns={dataFromStore.columns}
            filename={fileName}
            id="ExportTableData"
            style={{ color: "#212529" }}
          >
          </ExportTableData>
        )}
        {showdownloadAvalanche && (
          <ExportTableDataAvalanche
            data={dataFromStore.tableData}
            columns={dataFromStore.columns}
            filename={fileName}
            id="ExportTableDataAvalanche"
            style={{ color: "#212529" }}
          >
          </ExportTableDataAvalanche>
        )}
        {showImport && (
          <ImportPopup
            className="import__popup"
            show={showImport}
            data={data}
            title="Import File"
            handleToggle={importpop}
            importEndpoint={importEndpoint}
            downloadTemplate={downloadTemplate}
          />
        )}
      </span>
    </div>
  );
};
export default DMSHeader;

